module.exports = __webpack_public_path__ + "static/media/discover.259da6c9.svg";